import React from 'react';
import { useAppSelector } from 'src/redux';
import {
  announceWebAccount,
  useIsExtensionInstalled,
} from 'src/helpers/extensionBridge';
import { emailHash, maskEmail, rememberAccount } from 'src/helpers/lastAccount';
import getStoredToken, { isAdminMode } from 'src/helpers/storedToken';

/**
 * Keeps the "Continue as" cards current: remembers who signed in on this
 * browser, and tells the extension who abekus.ai is signed in as. Never in
 * Debug Mode, where the session is a learner impersonated on an admin's
 * browser and neither card may offer it.
 */
const useAccountMemory = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { id, email, first_name: firstName, picture } = user ?? {};
  // The extension's listener loads at document_idle, often after the user
  // does: say it again once it is there.
  const extensionHere = useIsExtensionInstalled();

  React.useEffect(() => {
    if (isAdminMode()) return;
    if (id && email) {
      rememberAccount({ email, first_name: firstName, picture });
      emailHash(email).then((hash) =>
        announceWebAccount({
          first_name: firstName || null,
          picture: picture || null,
          email_masked: maskEmail(email) as string,
          email_hash: hash,
        }),
      );
    } else if (!getStoredToken()) {
      // Signed out, not merely still loading the user.
      announceWebAccount(null);
    }
  }, [id, email, firstName, picture, extensionHere]);
};

export default useAccountMemory;
